export const redirectTo = (path: string): void => {
  window.location.assign(path);
};
